<template>
<div class="kdx-news-content">
    <div class="new-center-content">
        <div class="nav-crumb-top">
            <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
            <span @click="goHome">首页</span>/
            <span style="color:#05243D">CHA大讲堂</span>
        </div>
        <!-- <div class="center-tab">
            <span class="sp-tab_1" :class="{'active':type == 1}" @click="changeNews(1)">新闻列表</span>
            <span class="sp-tab_1" :class="{'active':type == 2}" @click="changeNews(2)">公告列表</span>
        </div> -->
        <div v-if="newsList.length > 0">
            <div class="kdx-news-list" v-for="(item,index) in newsList" :key="index">
                <div class="outer-layer">
                    <div class="kdx-news-li">
                        <p class="p-news-title">{{item.title}}</p>
                        <p class="p-news-date">{{item.date}}</p>
                        <p class="p-news-content" v-html="item.contentText">
                        </p>
                        <div class="btn-detail" @click="goNewsDetail(item.id)">查看详情</div>
                    </div>
                </div>
            </div>
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
        </div>
        <div v-else>
            <noData></noData>
        </div>
    </div>
    <!-- 手机端 -->
    <div class="ph-new-center-content">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i style="color:#05243D" class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span style="color:#05243D">CHA大讲堂</span>
            </div>
        </div>
        <!-- <div class="new-center-navigation clearfix">
            <h2 class="news-list" :class="{'activas':type == 1}" @click="changeNews(1)">新闻列表</h2>
            <h2 class="news-list" :class="{'activas':type == 2}" @click="changeNews(2)">公告列表</h2>
        </div> -->
        <v-refresh :on-refresh="onRefresh">
            <v-reload :on-infinite-load="onInfiniteLoad" :parent-pull-up-state="infiniteLoadData.pullUpState">
                <div class="new-center-list clearfix" v-for="(item,index) in phDetailsData" :key="index">
                    <div class="new-center-li" @click="goNewsDetail(item.id)">
                        <div class="new-center-left">
                            <p class="text-title">{{item.title}}</p>
                            <p class="text-date">{{item.date}}</p>
                            <p class="text-detail" v-html="item.contentText"></p>
                        </div>
                    </div>
                </div>
            </v-reload>
        </v-refresh>
    </div>
</div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
import noData from 'components/noData.vue';
export default {
    components: {
        "v-refresh": downFresh,
        "v-reload": pullUpReload,
        "noData": noData
    },
    data() {
        return {
            currentPage4: 10,
            tabs: 1,
            type: 3,
            newsList: [],
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            phDetailsData: [],
            infiniteLoadData: {
                initialShowNum: 3, // 初始显示多少条
                everyLoadingNum: 3, // 每次加载的个数
                pullUpState: 0, // 子组件的pullUpState状态
                pullUpList: [], // 上拉加载更多数据的数组
                showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
            }
        }
    },
    // props: {
    //     newsType: {
    //         type: [String, Number],
    //         default: 3
    //     }
    // },
    created() {
        // this.type = Number(this.newsType);
        this.getNewsr();
    },
    computed: {
        association: function () {
            return this.$store.state.association;
        }
    },
    methods: {
        onRefresh(done) {
            this.phDetailsData = [];
            this.getNewsr();
            done();
        },
        onInfiniteLoad(done) {
            this.getNewsr();
            done();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getNewsr();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getNewsr();
        },
        //返回首页
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        //新闻详情
        goNewsDetail(newsId) {
            this.$router.push({
                name: "chaClassDetail",
                params: {
                    newsId: newsId,
                    isTab: this.type
                }
            })
        },
        changeNews(data) {
            this.type = data;
            this.getNewsr();
        },
        //获取新闻列表
        getNewsr() {
            this.$http
                .post("/api/XOrg/AssociationIndex/getNewsr", {
                    type: this.type,
                    associationId: this.association.Id,
                    pageSize: this.pageSize,
                    page: this.pageIndex,
                })
                .then(rst => {
                    this.newsList = rst.list;
                    this.phDetailsData = rst.list;
                    this.pageSize = rst.pagination.pageSize;
                    this.totalCount = rst.pagination.totalCount;
                    if (this.phDetailsData.length == this.totalCount) {
                        this.infiniteLoadData.pullUpState = 3;
                    }
                });
        }
    }
}
</script>

<style lang="scss">
.kdx-news-content {
    width: 1200px;
    margin: 0 auto;

    .nav-crumb-top {
        margin-top: 23px;
    }

    .center-tab {
        margin-top: 27px;
        text-align: center;

        .sp-tab_1 {
            width: 94px;
            height: 37px;
            border: 1px solid #05243D;
            color: #05243D;
            display: inline-block;
            text-align: center;
            line-height: 37px;
            font-size: 14px;
            cursor: pointer;
        }

        .active {
            color: #fff;
            background: #05243D;
        }
    }

    .kdx-news-list {
        margin-top: 40px;

        .outer-layer {
            border-top: 4px solid #fff;
        }

        .kdx-news-li {
            margin: 28px 40px;
            border-bottom: 1px solid #E6E6E6;
            margin-bottom: 0;
        }

        .p-news-title {
            color: #05243D;
            font-size: 16px;
            font-weight: bold;
        }

        .p-news-date {
            color: #969696;
            font-size: 12px;
            margin: 14px 0;
        }

        .p-news-content {
            color: #646464;
            font-size: 14px;
            line-height: 23px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }

        .btn-detail {
            width: 90px;
            height: 30px;
            background: #05243D;
            color: #fff;
            text-align: center;
            line-height: 30px;
            margin: 26px 0 28px 0;
            cursor: pointer;
        }

        .outer-layer:hover {
            background: #F0F0F0;
            border-top: 4px solid #05243D;
            cursor: pointer;
        }
    }

    .el-pagination {
        padding: 35px 5px;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #05243D;
    }

    .ph-new-center-content {
        display: none;
    }
}

@media screen and (max-width: 980px) {
    .kdx-news-content {
        width: 100%;

        .new-center-content {
            display: none;
        }

        .el-block-pagination {
            display: none;
        }

        .ph-new-center-content {
            display: block;
            background: #fff;

            .crumbs-text {
                background: #F5F7FB;
                height: 40px;
                line-height: 40px;
                color: #666;

                span {
                    margin: 0 3px;
                }
            }

            .new-center-navigation {
                height: 32px;
                line-height: 32px;
                margin-top: 10px;
                padding: 0px 20px;

                .news-list {
                    background: #e6e6e6;
                    width: 90px;
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    float: left;
                }

                .activas {
                    background: #05243D;
                    color: #fff;
                }
            }

            .new-center-listnav {
                margin-bottom: 15px;
                border-bottom: 2px solid #E9EBF0;
                height: 38px;
                line-height: 38px;

                h2 {
                    font-size: 20px;
                    font-family: MicrosoftYaHei;
                    font-weight: 400;
                    width: 80px;
                    height: 100%;
                    float: left;
                    border-bottom: 2px solid #05243D;
                }

                .new-center-path {
                    float: right;

                    .wl-icon-zhuye1 {
                        color: #A4A4A4;
                        font-size: 16px;
                    }

                    span {
                        margin-left: 7px;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }

            .new-center-list {
                margin: 0px 20px;
                margin-bottom: 14px;
                padding-bottom: 10px;
                border-bottom: 1px solid #ccc;

                .new-center-li {
                    cursor: pointer;
                }

                .new-center-left {
                    width: 100%;

                    .text-title {
                        font-size: 14px;
                        font-family: MicrosoftYaHei-Bold;
                        font-weight: bold;
                        margin-bottom: 6px;
                        margin-top: 4px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: #05243D;
                    }

                    .text-date {
                        line-height: 25px;
                        color: #606060;
                        font-size: 12px;
                    }

                    .text-detail {
                        font-size: 13px;
                        height: 37px;
                        font-family: MicrosoftYaHei;
                        color: #606060;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        line-height: 1.5;

                        img {
                            display: none;
                        }
                    }
                }
            }

            .new-center-li:hover {
                .text-title {
                    color: #2D82FF;
                }
            }
        }
    }
}
</style>
